import { MapHelper } from '../functions/MapHelper';

class UserlistSection {

	constructor(name, acceptUsersFunction, sortFunction) {
		this.name = name;
		this.acceptUsersFunction = acceptUsersFunction;
		this.sortFunction = sortFunction;

		this.showWhenEmpty = false;
		this.toggledOn = true;

		this.onToggleOn = null;
		this.afterToggleOn = null;

		this.users = new Map();
		return this;
	}

	toggle() {
		if(this.toggledOn) {
			this.toggledOn = false;
		}
		else {
			this.toggledOn = true;
			if(this.onToggleOn) {
				this.loading = true;
				return this.onToggleOn()
					.then((users) => {
						this.loading = false;
					})
					.finally(() => {
						this.loading = false;
						if(this.afterToggleOn) {
							this.afterToggleOn();
						}
					});
			}
		}
		return Promise.resolve();
	}

	canHold(user) {
		if(this.acceptUsersFunction === true) {
			return true;
		}
		if(this.acceptUsersFunction(user)) {
			return true;
		}
		return false;
	}

	clear() {
		this.users.clear();
	}

	addToCounterUserlist(user) {
		this.users.set(user.id, user);
	}

	getCount() {
		return this.users.size;
	}

	removeUserFromSection(user) {
		this.users.delete(user.id);
	}

	sort() {
		if(!this.sortFunction) {
			return;
		}
		MapHelper.inPlaceSort(this.users, this.sortFunction);
		return this.users;
	}

}

export { UserlistSection };